/**
 * Centralized API exports and initialization
 * All API clients are now generated by Orval from OpenAPI schema
 */
import { setCsrfTokenGetter } from './custom-fetch';

// Export all generated endpoint functions
export * from './generated/endpoints';

// Export all generated type models
export * from './generated/models';

// Export CSRF token setter from custom fetch
export { setCsrfTokenGetter };

// Initialize all APIs with CSRF token getter
export const initializeAPIs = (csrfTokenGetter: () => Promise<string>) => {
  setCsrfTokenGetter(csrfTokenGetter);
};